module.exports = __webpack_public_path__ + "0fd582270564deef2641eabed46508df.woff";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Black.woff
// module id = 652
// module chunks = 0